import CardImage from './CardImage'
import CardImageHeading from './CardImageHeading'

CardImage.Heading = CardImageHeading

export default CardImage
